import { jsx as _jsx } from "react/jsx-runtime";
import { useMouseTracker } from '../../../EventsTrackers/MouseTracker';
import { SpectrumPhaseTrace } from './SpectrumPhaseTrace';
export function PhaseTraceWithMouse() {
    const position = useMouseTracker();
    if (!position) {
        return null;
    }
    return _jsx(SpectrumPhaseTrace, { positionUnit: "Pixel", position: position });
}
